/* eslint-disable import/no-unresolved */
/* eslint-disable no-undef */
/* eslint-disable no-case-declarations */
import { fromJS, remove, merge } from 'immutable';
// import Cookies from "js-cookie";
// import { getParamsUrlString } from "../helpers";

import { listTranslate } from './data/flag-translate';

import * as types from '../constants';

const defaultState = fromJS({
  appStatusTranslate: true,
  autoConvert: false,
  positionStatus: false,
  position: 100,
  showDesktop: true,
  showMobile: true,
  positionFloat: 'float',
  translationBeside: 'box',
  selectedTranslate: [],
  translation: [],
  checkboxAllTranslate: [],
  translationTemporary: [],
  jsonData: [],
  listTranslate,
  translationSearch: '',
  translationTheme: 'name',
  textColor: '#000000',
  backgroundColor: '#FFF',
  hoverBackgroundColor: '#e1e2e1',
  borderColor: '#e1e2e1',
  activeTranslate: [],
  margin: {
    top: 2,
    bottom: 2,
    left: 2,
    right: 2
  },
  save: '',
  progressBarTranslate: 100,
  popDropdown: 'pop',
  borderWidth: 3,
  billingStatus: '',
  translate: '',
  font: {
    size: '',
    weight: 'bold'
  },
  checkCode: false,
  showPreview: 'desktop',
  shopDomain: ''
});

function getIndex(value, arr, prop) {
  for (let i = 0; i < arr.size; i++) {
    if (arr.getIn([i, prop]) === value) {
      return i;
    }
  }
  return -1; // to handle the case where the value doesn't exist
}
function checkNull(arr) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] === null || arr[i] === '') {
      return i;
    }
  }
  return -1; // to handle the case where the value doesn't exist
}

function getValueAllTranslate(arr) {
  let valueAll = [];
  for (let i = 0; i < arr.size; i++) {
    valueAll = merge(valueAll, [arr.getIn([i, 'value'])]);
  }
  return valueAll; // to handle the case where the value doesn't exist
}

export const getCart = state => state.translationReducer;

const translationReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.TURN_ON_OFF:
      return state.set(action.value, !state.get(action.value));
    case types.CHANGE_POSITION_TRANSLATE:
      return state.set('position', action.value);
    case types.CHANGE_POSITION_FLOAT_TRANSLATE:
      return state.set('positionFloat', action.value);
    case types.CHANGE_POP_DROPDOWN:
      return state.set('popDropdown', action.value);
    case types.CHANGE_TRANSLATE_BESIDE:
      return state.set('translationBeside', action.value);

    case types.DELETE_ALL_TRANSLATE:
      return state
        .set('selectedTranslate', fromJS([]))
        .set('translation', fromJS([]))
        .set('checkboxAllTranslate', [])
        .set('translationTemporary', fromJS([]));

    case types.CHECKBOX_ALL_TRANSLATE:
      const valueAllTranslate = getValueAllTranslate(state.get('listTranslate'));
      if (action.value[0] === 'checked') {
        return state.set('translationTemporary', fromJS(valueAllTranslate)).set('checkboxAllTranslate', ['checked']);
      }
      return state.set('translationTemporary', fromJS([])).set('checkboxAllTranslate', []);
    case types.TRANSLATE_TEMPORARY:
      return state
        .set('translationTemporary', state.get('translation'))
        .set('checkboxAllTranslate', state.get('translation').size === 104 ? ['checked'] : []);
    case types.CHOOSE_TRANSLATE:
      let checkboxAllTranslate;
      if (action.value.length === 104) {
        checkboxAllTranslate = ['checked'];
      } else {
        checkboxAllTranslate = [];
      }
      return state.set('translationTemporary', fromJS(action.value)).set('checkboxAllTranslate', checkboxAllTranslate);

    case types.ADD_TRANSLATE:
      const translationArray = state.get('translationTemporary');
      let index = '';
      let translation = fromJS([]);
      for (let i = 0; i < translationArray.size; i++) {
        index = getIndex(translationArray.get(i), state.get('listTranslate'), 'value');
        translation = merge(translation, [state.getIn(['listTranslate', index])]);
      }
      return state.set('selectedTranslate', translation).set('translation', translationArray);

    case types.DELETE_TRANSLATE:
      const i = state.get('selectedTranslate').indexOf(action.value);
      const j = state.get('translation').indexOf(action.value.get('code'));
      return state
        .set('selectedTranslate', remove(state.get('selectedTranslate'), i))
        .set('translation', remove(state.get('translation'), j))
        .set('checkboxAllTranslate', []);
    case types.ARRAY_MOVE_TRANSLATE:
      return state
        .set('selectedTranslate', fromJS(action.selectedTranslate))
        .set('translation', fromJS(action.translation));

    case types.CHANGE_TRANSLATE_SEARCH:
      return state.set('translationSearch', action.value);
    case types.CHANGE_THEME_TRANSLATE:
      return state.set('translationTheme', action.value);

    case types.CHANGE_FONT_TRANSLATE:
      return state.setIn(['font', action.name], action.value);

    case types.CHANGE_COLOR_TRANSLATE:
      return state.set(action.name, action.value);

    case types.CHANGE_MARGIN:
      return state.setIn(['margin', action.payload.field], action.payload.value);
    case types.CHANGE_FONT_SIZE:
      return state.setIn(['font', action.payload.field], action.payload.value);

    case types.CHANGE_BORDER_WIDTH:
      return state.set('borderWidth', action.value);

    case types.SET_SHOP_SETTINGS_TRANSLATE:
      if (action.data) {
        let checkCode = state.get('checkCode');
        let translateshop = state.get('translate');
        translateshop =
          Array.isArray(action.data.translate) && action.data.translate.length > 0
            ? action.data.translate
            : JSON.stringify([{ label: 'English', value: 'en', code: 'en.png' }]);
        if (action.checkCode) {
          checkCode = !state.get('checkCode');
        }
        let selectedTranslate = action.data.json_data ? JSON.parse(action.data.json_data) : [];

        const listTranslateNew = state.get('listTranslate');
        const translateShop = listTranslateNew.get(
          getIndex(JSON.parse(translateshop), fromJS(listTranslateNew), 'value')
        );
        if (selectedTranslate.length === 0 || checkNull(selectedTranslate) >= 0) {
          selectedTranslate = [{ label: 'English', value: 'en', code: 'en.png' } || translateShop];
        }
        selectedTranslate = fromJS(selectedTranslate);

        let barSetting = action.data.progress_bar_translate;
        if (action.data.progress_bar_translate === 0) {
          barSetting = 50;
        }
        return state
          .set('position', action.data.position)
          .set('positionFloat', action.data.position_float)
          .setIn(['margin', 'top'], action.data.margin_top)
          .setIn(['margin', 'left'], action.data.margin_left)
          .setIn(['margin', 'bottom'], action.data.margin_bottom)
          .setIn(['margin', 'right'], action.data.margin_right)
          .set('positionFloat', action.data.position_float)
          .set('backgroundColor', action.data.background_color)
          .set('hoverBackgroundColor', action.data.background_color_hover)
          .set('textColor', action.data.text_color)
          .set('borderColor', action.data.border_color)
          .set('borderWidth', action.data.border_width)
          .setIn(['font', 'weight'], action.data.font_weight)
          .setIn(['font', 'size'], action.data.font_size)
          .set('popDropdown', action.data.list_display)
          .set('positionStatus', action.data.show_translate_position)
          .set('autoConvert', action.data.auto_convert)
          .set('selectedTranslate', selectedTranslate)
          .set('checkCode', checkCode)
          .set('translate', translateshop)
          .set('progressBarTranslate', barSetting)
          .set('translation', fromJS(getValueAllTranslate(selectedTranslate)))
          .set('activeTranslate', selectedTranslate.label)
          .set('showDesktop', action.data.is_show_desktop)
          .set('showMobile', action.data.is_show_mobile)
          .set('appStatusTranslate', action.data.translate_status);
      }

      return state;

    // .set("shopDomain", shopDomain);
    case types.CHANGE_TRANSLATE_SETTING_FIELD:
      return state.set(action.payload.field, action.payload.value);
    case types.SAVE_SETTINGS_TRANSLATE:
      return state.set('save', 'loading');
    case types.CHANGE_DISPLAY_DEVICE_TRANSLATE:
      return state.set(action.payload, !state.get(action.payload));
    case types.SAVE_SETTINGS_RESPONSE_TRANSLATE:
      const progressBar = state.get('progressBarTranslate') <= 50 ? 100 : state.get('progressBarTranslate');
      if (action.data.success === true) {
        return state.set('save', 'success').set('progressBarTranslate', progressBar);
      }
      return state.set('save', 'error');

    case types.CHANGE_PREVIEW:
      let position = state.get('position');
      if (
        (action.value === 'mobile' && position === 5) ||
        (action.value === 'mobile' && position === 4) ||
        (action.value === 'mobile' && position === 2) ||
        (action.value === 'mobile' && position === 7)
      ) {
        position = 6;
      }
      return state.set('showPreview', action.value).set('position', position);

    default:
      return state;
  }
};

export default translationReducer;
